export const formatPrice = (price: number, prefix: string = "zł") => {
  return price.toFixed(2) + " " + prefix;
};

export const toNumber = (price: string): number => {
  return Number(price) / 100;
};
